import { ApiFunc, getInstance } from '@helpers/httpClient'
import { prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const sdFeedbackResponseCreate: ApiFunc<`${typeof API.SD_FEEDBACK_RESPONSE}`, 'post'> = data =>
  instance.post(API.SD_FEEDBACK_RESPONSE, data)

export const sdFeedbackResponseDelete: ApiFunc<`${typeof API.SD_FEEDBACK_RESPONSE}{id}`, 'delete'> = data =>
  instance.delete(`${API.SD_FEEDBACK_RESPONSE}${'id' in data ? prop('id', data) : data?.name}`)

export const sdFeedbackResponseAll: ApiFunc<`${typeof API.SD_FEEDBACK_RESPONSE_ALL}`, 'get'> = data =>
  instance.get(API.SD_FEEDBACK_RESPONSE_ALL, { params: data })

export const sdFeedbackEvalCampaignCreate: ApiFunc<`${typeof API.SD_FEEDBACK_EVALUATION_CAMPAIGN}`, 'post'> = data =>
  instance.post(API.SD_FEEDBACK_EVALUATION_CAMPAIGN, data)

export const sdFeedbackEvalCampaignDelete: ApiFunc<
  `${typeof API.SD_FEEDBACK_EVALUATION_CAMPAIGN}{id}`,
  'delete'
> = data => instance.delete(`${API.SD_FEEDBACK_EVALUATION_CAMPAIGN}${'id' in data ? prop('id', data) : data?.name}`)

export const sdFeedbackEvalCampaignCurrent: ApiFunc<
  `${typeof API.SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT}`,
  'get'
> = data => instance.get(API.SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT, { params: data })

export const sdFeedbackEvaluationCreate: ApiFunc<`${typeof API.SD_FEEDBACK_EVALUATION}`, 'post'> = data =>
  instance.post(API.SD_FEEDBACK_EVALUATION, data)

export const sdFeedbackEvaluationByEvaluator: ApiFunc<
  `${typeof API.SD_FEEDBACK_EVALUATION_BY_EVALUATOR}`,
  'get'
> = data => instance.get(API.SD_FEEDBACK_EVALUATION_BY_EVALUATOR, { params: data })

export const sdFeedbackEvaluationBySubject: ApiFunc<`${typeof API.SD_FEEDBACK_EVALUATION_BY_SUBJECT}`, 'get'> = data =>
  instance.get(API.SD_FEEDBACK_EVALUATION_BY_SUBJECT, { params: data })

export const sdFeedbackEvaluationEvaluateInfo: ApiFunc<
  `${typeof API.SD_FEEDBACK_EVALUATION_EVALUATE_INFO}`,
  'get'
> = data => instance.get(API.SD_FEEDBACK_EVALUATION_EVALUATE_INFO, { params: data })

export const sdFeedbackQuestionDelete: ApiFunc<`${typeof API.SD_FEEDBACK_QUESTION}{id}`, 'delete'> = data =>
  instance.delete(`${API.SD_FEEDBACK_QUESTION}${'id' in data ? prop('id', data) : data?.name}`)

export const sdFeedbackStaffAssignCreate: ApiFunc<`${typeof API.SD_FEEDBACK_STAFF_ASSIGN}`, 'post'> = data =>
  instance.post(API.SD_FEEDBACK_STAFF_ASSIGN, data)

export const sdFeedbackStaffAssignDelete: ApiFunc<`${typeof API.SD_FEEDBACK_STAFF_ASSIGN}{id}`, 'delete'> = data =>
  instance.delete(`${API.SD_FEEDBACK_STAFF_ASSIGN}${'id' in data ? prop('id', data) : data?.name}`)

export const sdFeedbackStaffAssignStaffList: ApiFunc<`${typeof API.SD_FEEDBACK_STAFF_ASSIGN_STAFF}`, 'get'> = data =>
  instance.get(API.SD_FEEDBACK_STAFF_ASSIGN_STAFF, { params: data })

export const sdFeedbackStaffAssignPrincipalList: ApiFunc<
  `${typeof API.SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL}`,
  'get'
> = data => instance.get(API.SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL, { params: data })

export const sdFeedbackStaffAssignedEvaluatorsAll: ApiFunc<
  `${typeof API.SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL}`,
  'get'
> = data => instance.get(API.SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL, { params: data })

export const sdFeedbackStaffAssignSubjectAll: ApiFunc<
  `${typeof API.SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL}`,
  'get'
> = data => instance.get(API.SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL, { params: data })

export const sdFeedbackQuestionAll: ApiFunc<`${typeof API.SD_FEEDBACK_QUESTION_ALL}`, 'get'> = data =>
  instance.get(API.SD_FEEDBACK_QUESTION_ALL, { params: data })

export const sdFeedbackEvaluationStatsOpenEnded: ApiFunc<
  `${typeof API.SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED}`,
  'get'
> = data => instance.get(API.SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED, { params: data })

export const sdFeedbackEvaluationStats: ApiFunc<`${typeof API.SD_FEEDBACK_EVALUATION_STATS}`, 'get'> = data =>
  instance.get(API.SD_FEEDBACK_EVALUATION_STATS, { params: data })
